export const SET_MFA_DIALOG = "setMfaDialog"
export const SET_CONSENT_ACCEPTED_OPTIONS = "setConsentAcceptedOptions"
export const SET_TENANT_SETTINGS = "setTenantSettings"
export const INITIALIZE_SDK = "initializeSDK"
export const SET_CURRENT_USER = "setCurrentUser"
export const SET_AUTHENTICATED = "setAuthenticated"
export const SET_LOADING = "setLoading"
export const SET_SDK_ERROR = "setSDKError"
export const TOGGLE_BACKDROP = "toggleBackdrop"
export const SET_TENANT_ID = "setTenantId"
export const SET_CONFIG = "setConfig"
export const SET_ERROR = "setError"
export const SET_CONSENT_DECISIONS = "setConsent"
export const SET_VERIFF_SESSION_DATA = "setVeriffSessionData"
export const SET_CURRENT_USER_MARKET = "setCurrentUserMarket"
